import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "space"
  static values = { name: String }

  connect() {
    super.connect()
    this.send("changed", { space: this.nameValue })
  }
}
